import { Shield, User, Crown } from 'lucide-react';
import { Company } from './types';

const getCompanyName = (companyId: string, companies: Company[]): string => {
  const company = companies.find((c: Company) => c.id === companyId);
  return company?.name || 'Unknown Company';
};

const getRoleIcon = (role: string): JSX.Element => {
  switch (role) {
    case 'super_admin':
      return <Crown size={16} className="text-yellow-600" />;
    case 'admin':
      return <Shield size={16} className="text-purple-600" />;
    default:
      return <User size={16} className="text-blue-600" />;
  }
};

const getRoleBadge = (role: string): string => {
  const colors = {
    user: 'bg-blue-100 text-blue-800',
    admin: 'bg-purple-100 text-purple-800',
    super_admin: 'bg-yellow-100 text-yellow-800',
  };
  return colors[role as keyof typeof colors] || colors.user;
};

export { getCompanyName, getRoleIcon, getRoleBadge };
